import React, { useEffect, useState } from "react";

import s from "./media.module.scss";
import { FaPlay } from "react-icons/fa";

import Modal from "../Modal";
import EmptyMessage from "../EmptyMessage";
import RenderIf from "../../utils/renderIf";
import { BACKDROP_NOT_FOUND, BACKDROP_URL } from "../../utils/constants";
import useMatch from "../../hooks/useMatch";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Media = ({ data, isPhotos }) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [mediaPath, setMediaPath] = useState("");
  const match = useMatch(600);

  const handleClick = (path) => {
    setIsOpenModal(true);
    setMediaPath(path);
  };

  useEffect(() => {
    if (isOpenModal) {
      document.querySelector("body").classList.add("disable_scroll");
    } else {
      document.querySelector("body").classList.remove("disable_scroll");
    }
  }, [isOpenModal]);

  return (
    <>
      {data.length ? (
        <div className={`${s.media_outer} fade_in`}>
          <div className={s.media_inner}>
            {data?.map((el, i) => {
              const { file_path, key, name, type } = el;

              const photoSrc = file_path
                ? BACKDROP_URL + file_path
                : BACKDROP_NOT_FOUND;
              const videoSrc = `https://i3.ytimg.com/vi/${key}/maxresdefault.jpg`;

              return (
                <div key={i} className={s.media_item}>
                  <figure>
                    <picture>
                      <LazyLoadImage
                        src={isPhotos ? photoSrc : videoSrc}
                        alt="media"
                        effect="blur"
                        onClick={
                          match ? () => handleClick(file_path) : () => {}
                        }
                      />
                    </picture>
                  </figure>
                  <RenderIf isTrue={!isPhotos}>
                    <div className={s.video_info_outer}>
                      <div className={s.icon}>
                        <FaPlay onClick={() => handleClick(key)} />
                      </div>
                      <div className={s.video_info_inner}>
                        <h4>{name}</h4>
                        <p>{type}</p>
                      </div>
                    </div>
                  </RenderIf>
                </div>
              );
            })}
            <RenderIf isTrue={isOpenModal}>
              <Modal setOpen={setIsOpenModal}>
                {isPhotos ? (
                  <img src={BACKDROP_URL + mediaPath} alt="media" id="img" />
                ) : (
                  <iframe
                    title="frame"
                    src={`https://www.youtube.com/embed/${mediaPath}?autoplay=1&mute=1`}
                    frameBorder="0"
                    allowFullScreen
                    id="video"
                  />
                )}
              </Modal>
            </RenderIf>
          </div>
        </div>
      ) : (
        <EmptyMessage msg="No media" isHalf />
      )}
    </>
  );
};

export default Media;
